import { Shark } from "shark-mvc";
import NousCoreModel from "./NousCoreModel";

class ContentRelation extends NousCoreModel {
	bidirectional = true;
	content1Guid = "";
	content1Type = "";
	content2Guid = "";
	content2Type = "";
	extraData = {};
	
	constructor (data) {
		super();

		if (data) {
			this.import(data);
		}
	}

	export () {
		const exportData = super.export();

		exportData.extraData = this.exportObjectField("extraData");
		exportData.bidirectional = this.exportBooleanField("bidirectional");
		
		return exportData;
	}

	import (data, options) {
		super.import(data, options);
		
		this.importBooleanField("bidirectional", data.bidirectional);

		// this.parseTags();
	}
	
	// parseTags () {
	// 	this.__tags = JSON.stringify(this.tags);
	// }
}

Shark.registerModel("ContentRelation", ContentRelation);

export default ContentRelation;